import React, { useState } from "react";
import { Card, Tag, Space, Button, Typography } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { decodeStr } from "../../../utils";
import UserLinks from "../../shared/UserLinks";
import ReactJson from "@microlink/react-json-view";
import Auth0UserBlockControl from "../../shared/Auth0UserBlockControl";

const { Text } = Typography;

const UserCard = ({
  user,
  onSync,
  syncing,
  canManageAuth0Blocks,
  auth0Checking,
  auth0Unlocking,
  onAuth0Check,
  onAuth0Unblock,
}) => {
  const [expanded, setExpanded] = useState(false);

  const fullName = [
    decodeStr(user.first_name || ""),
    decodeStr(user.last_name || ""),
  ]
    .filter(Boolean)
    .join(" ") || "Utente";

  const roleColors = {
    Amministratore: "purple",
    Collaboratore: "geekblue",
  };

  return (
    <Card className="user-card" size="small">
      {/* Header with Name and Status */}
      <div className="user-card-header">
        <div className="user-card-name">{fullName}</div>
        <Space size={4}>
          {user.ruolo && (
            <Tag color={roleColors[user.ruolo] || "blue"}>{user.ruolo}</Tag>
          )}
          <Tag color={user.user_status ? "green" : "volcano"}>
            {user.user_status ? "ATTIVO" : "DISATTIVO"}
          </Tag>
        </Space>
      </div>

      {/* ID */}
      <div className="user-card-id">
        <Text type="secondary">ID: {user.objectId}</Text>
      </div>

      {/* Contact Info */}
      <div className="user-card-info">
        {user.email && (
          <div className="user-card-row">
            <Text type="secondary">Email:</Text>
            <Text>{user.email}</Text>
          </div>
        )}
        {user.telefono && (
          <div className="user-card-row">
            <Text type="secondary">Telefono:</Text>
            <Text>{user.telefono}</Text>
          </div>
        )}
      </div>

      {canManageAuth0Blocks && (
        <div className="user-card-links">
          <Auth0UserBlockControl
            user={user}
            checking={auth0Checking}
            unlocking={auth0Unlocking}
            onCheck={onAuth0Check}
            onUnblock={onAuth0Unblock}
          />
        </div>
      )}

      {/* Links */}
      <div className="user-card-links">
        <UserLinks user={user} size="small" />
      </div>

      {/* Expand/Collapse Button */}
      <div className="user-card-expand">
        <Button
          type="text"
          size="small"
          icon={expanded ? <UpOutlined /> : <DownOutlined />}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Nascondi dettagli" : "Mostra dettagli"}
        </Button>
      </div>

      {/* Expanded Content */}
      {expanded && (
        <div className="user-card-expanded">
          <ReactJson src={user} name={null} collapsed={1} />
          <div style={{ marginTop: 12 }}>
            <Button
              type="primary"
              size="small"
              onClick={() => onSync(user.objectId)}
              loading={syncing}
              block
            >
              Sincronizza utente con CRM Zoho
            </Button>
          </div>
        </div>
      )}
    </Card>
  );
};

export default UserCard;
